import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable }    from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  //  public static NODE_API_URL = "https://node-backend.chapwood.apps.savantly.cloud/";
  // public static NODE_API_URL = "http://13.57.236.169:3000/";
  public static NODE_API_URL = "https://node-backend.chapwood.apps.savantly.cloud/";
  // public static CHAPVEST_PATH = "http://13.57.236.169/resources/";
  // public static RESOURCES_PATH = "http://13.57.236.169/static_files/";
  // public static CHAPTIMIZER_API_URL = "http://127.0.0.1:5002/";
  public static CHAPTIMIZER_API_URL = "https://chapwood-optimizer.chapwood.apps.savantly.cloud/";


  public static RESOURCES_PATH = "./assets";
  constructor(public http: HttpClient) {

  }
  public isVidLoading=true;
  public html_body = '';
  enhancerTypes = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18
  ];
  enhancers = {
    portfolio_percentage: 20,
    percentage_total: 100,
    ENHANCERS: [
      {
        enhancer_name: "Enhancer 1",
        enhancer_id: 1,
        percentage: 40,
        portfolio_percentage: 8
      },
      {
        enhancer_name: "Enhancer 2",
        enhancer_id: 2,
        percentage: 30,
        portfolio_percentage: 6
      },
      {
        enhancer_name: "Enhancer 3",
        enhancer_id: 3,
        percentage: 30,
        portfolio_percentage: 6
      }
    ]
  }

  calculateEnhancerPercentageTotal(){
    for (let i of this.enhancers.ENHANCERS){
      i.portfolio_percentage = this.enhancers.portfolio_percentage * (i.percentage / 100.0);
    }
  }
  public portfolioValueSource = new BehaviorSubject<string>('');
  currentPortfolioValue = this.portfolioValueSource.asObservable();
  public managementFeeSource = new BehaviorSubject<string>('');
  currentManagementFee = this.managementFeeSource.asObservable();
  public investmentFeeSource = new BehaviorSubject<string>('');
  currentInvestmentFee = this.investmentFeeSource.asObservable();
  public taxBracketSource = new BehaviorSubject<string>('');
  currentTaxBracket = this.taxBracketSource.asObservable();
  public costOfLivingIncreaseSource = new BehaviorSubject<string>('');
  currentCostOfLivingIncrease = this.costOfLivingIncreaseSource.asObservable();
  public enhancerAllocationSource = new BehaviorSubject<string>('');
  currentEnhancerAllocation = this.enhancerAllocationSource.asObservable();
  public enhancerNumberSource = new BehaviorSubject<string>('');
  currentEnhancerNumber = this.enhancerNumberSource.asObservable();
  editPortfolioValue(newPortfolioValue){
    this.portfolioValueSource.next(newPortfolioValue);
  }
  editManagementFee(newManagementFee){
    this.managementFeeSource.next(newManagementFee);
  }
  editInvestmentFee(newInvestmentFee){
      this.investmentFeeSource.next(newInvestmentFee);
  }
  editTaxBracket(newTaxBracket){
    this.taxBracketSource.next(newTaxBracket);
  }
  editCostOfLivingIncrease(newCostOfLivingIncrease){
    this.costOfLivingIncreaseSource.next(newCostOfLivingIncrease);
  }
  editEnhancerAllocation(newEnhancerAllocationRate){
    this.enhancerAllocationSource.next(newEnhancerAllocationRate);
  }
  editEnhancerNumber(newEnhancerNumber){
    this.enhancerNumberSource.next(newEnhancerNumber);
  }
  ////////////////////////////////////////////////////////////////////////////
  // Chip score observables



  // Chipscore modal
  public lastNameSource = new BehaviorSubject<string>('');
  currentLastName = this.lastNameSource.asObservable();
  public phoneSource = new BehaviorSubject<string>('');
  currentPhone = this.phoneSource.asObservable();
  public emailSource = new BehaviorSubject<string>('');
  currentEmail = this.emailSource.asObservable();
  editLastName(newLastName){
      this.lastNameSource.next(newLastName);
  }
  editPhone(newPhone){
      this.phoneSource.next(newPhone);
  }
  editEmail(newEmail){
      this.emailSource.next(newEmail);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////

  /** ============================================ STATISTICS REST API ========================================================= */
  /**
   * Makes a GET request for a specfic statistic
   * @param id The id of the statistic
   */
  getStatistic(id){
    var url = UserService.NODE_API_URL+'statistics/' + id
    return this.http.get(url);
  }
  /**
   * Makes a GET request for all statistics
   */
  getStatistics(){
      return this.http.get(UserService.NODE_API_URL+'statistics');
  }
  /**
   * Makes a POST request for a statistic creating a new statistic
   * @param newStatistic The body of the request for a statistic/The new statistic object to be added
   */
  addStatistic(newStatistic){
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.http.post(UserService.NODE_API_URL+'statistics', newStatistic, {headers: headers});
  }
  /**
   * Makes a DELETE request for a specific statistic
   * @param id The id of the statistic to be deleted
   */
  deleteStatistic(id){
      return this.http.delete(UserService.NODE_API_URL+'statistics/'+id);
  }
  /** ======================================== ALLOCATIONS REST API ================================================== */
  /**
   * Makes a GET request for a specfic allocation
   * @param id The id of the allocation
   */
  getAllocation(id){
    var url = UserService.NODE_API_URL+'allocations/' + id
    return this.http.get(url);
  }
  /**
   * Makes a POST request for an allocation creating a new allocation
   * @param newAllocation  The body of the request for an allocation/The new income expense object to be added
   */
  addAllocation(newAllocation){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      // headers.append('Content-Type', 'application/json');
      return this.http.post(UserService.NODE_API_URL+'allocations', newAllocation, {headers: headers});
  }
  /**
   * Makes a PATCH request for an existing allocation
   * @param id The id of the allocation to be edited
   * @param body  The body of the request for an allocation
   */
  editAllocation(id, body){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      return this.http.patch(UserService.NODE_API_URL+'allocations/'+id, body);
  }
  /**
   * Makes a DELETE request for a specific allocation
   * @param id The id of the allocation to be deleted
   */
  deleteAllocation(id){
      return this.http.delete(UserService.NODE_API_URL+'allocations/'+id);
  }

  /** ======================================== ENHANCED REST API ================================================== */
  /**
   * Makes a GET request for a specfic enhancer
   * @param id The id of the enhancer
   */
  getEnhancer(id){
    var url = UserService.NODE_API_URL+'enhancers/' + id
    return this.http.get(url);
  }
  /**
   * Makes a POST request for an enhancer creating a new enhancer
   * @param newEnhancer  The body of the request for an enhancer/The new income expense object to be added
   */
  addEnhancer(newEnhancer){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      // headers.append('Content-Type', 'application/json');
      return this.http.post(UserService.NODE_API_URL + 'enhancers', newEnhancer, {headers: headers});
  }
  /**
   * Makes a PATCH request for an existing enhancer
   * @param id The id of the enhancer to be edited
   * @param body  The body of the request for an enhancer
   */
  editEnhancer(id, body){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      return this.http.patch(UserService.NODE_API_URL +'enhancers/' + id, body);
  }
  /**
   * Makes a DELETE request for a specific enhancer
   * @param id The id of the enhancer to be deleted
   */
  deleteEnhancer(id){
      return this.http.delete(UserService.NODE_API_URL + 'enhancers/' + id);
  }
  /** ======================================== CHIPSCORE REST API ================================================== */
    /**
     * Makes a GET request for a specfic chipscore
     * @param id The id of the chipscore
     */
    getChipscore(id){
      var url = UserService.NODE_API_URL+'chipscores/' + id
      return this.http.get(url);
  }
  /**
   * Makes a POST request for an chipscore creating a new chipscore
   * @param newChipscore  The body of the request for an chipscore/The new income expense object to be added
   */
  addChipscore(newChipscore){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      // headers.append('Content-Type', 'application/json');
      return this.http.post(UserService.NODE_API_URL+'chipscores', newChipscore, {headers: headers});
  }
  /**
   * Makes a PATCH request for an existing chipscore
   * @param id The id of the chipscore to be edited
   * @param body  The body of the request for an chipscore
   */
  editChipscore(id, body){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      return this.http.patch(UserService.NODE_API_URL+'chipscores/'+id, body);
  }
  /**
   * Makes a DELETE request for a specific chipscore
   * @param id The id of the chipscore to be deleted
   */
  deleteChipscore(id){
      return this.http.delete(UserService.NODE_API_URL+'chipscores/'+id);
  }

  /** ======================================== CONTACT REST API ================================================== */
  /**
   * Makes a GET request for a specfic contact
   * @param id The id of the contact
   */
  getContact(id){
      var url = UserService.NODE_API_URL+'contacts/' + id
      return this.http.get(url);
  }
  /**
   * Makes a POST request for an contact creating a new contact
   * @param newContact  The body of the request for an contact/The new income expense object to be added
   */
  addContact(newContact){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      // headers.append('Content-Type', 'application/json');
      return this.http.post(UserService.NODE_API_URL+'contacts', newContact, {headers: headers});
  }
  /**
   * Makes a PATCH request for an existing contact
   * @param id The id of the contact to be edited
   * @param body  The body of the request for an contact
   */
  editContact(id, body){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      return this.http.patch(UserService.NODE_API_URL+'contacts/'+id, body);
  }
  /**
   * Makes a DELETE request for a specific contact
   * @param id The id of the contact to be deleted
   */
  deleteContact(id){
      return this.http.delete(UserService.NODE_API_URL+'contacts/'+id);
  }

  /** ======================================== INCOME_EXPENSES REST API ================================================== */
    /**
     * Makes a GET request for all income_expenses
     */
    getIncomesExpenses(){
      return this.http.get(UserService.NODE_API_URL+'incomes_expenses');
  }
  /**
   * Makes a GET request for a specific income_expense
   * This method patches the associated statistic as well
   * @param id The id of the income_expense
   */
  getIncomeExpense(id){
      var url = UserService.NODE_API_URL+'incomes_expenses/' + id;
      return this.http.get(url);
  }
  /**
   * Makes a POST request for an income_expense creating a new income_expense
   * @param newIncomeExpense  The body of the request for an income_expense/The new income expense object to be added
   */
  addIncomeExpense(newIncomeExpense){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      // headers.append('Content-Type', 'application/json');
      return this.http.post(UserService.NODE_API_URL+'incomes_expenses', newIncomeExpense, {headers: headers});
  }
  /**
   * Makes a PATCH request for an existing income_expense
   * @param id The id of the income_expense to be edited
   * @param body  The body of the request for an income_expense
   */
  editIncomeExpense(id, body){
      var headers = new HttpHeaders();
      headers.set('Content-Type', 'application/json');
      headers.set('Access-Control-Allow-Origin', '*');
      headers.keys
      return this.http.patch(UserService.NODE_API_URL+'incomes_expenses/'+id, body);
  }
  /**
   * Makes a DELETE request for a specific income_expense
   * @param id The id of the income_expense to be deleted
   */
  deleteIncomeExpense(id){
      return this.http.delete(UserService.NODE_API_URL+'incomes_expenses/'+id);
  }

   //to get pdf file

   downloadPdf()
   {
     return UserService.CHAPTIMIZER_API_URL
   }


   getCaptureRatioURL(){
    return UserService.CHAPTIMIZER_API_URL + 'capture_ratio'
   }

}
